import { render, staticRenderFns } from "./IntegrationPainelCustomer.vue?vue&type=template&id=3618abea&scoped=true"
import script from "./IntegrationPainelCustomer.vue?vue&type=script&lang=js"
export * from "./IntegrationPainelCustomer.vue?vue&type=script&lang=js"
import style0 from "./IntegrationPainelCustomer.vue?vue&type=style&index=0&id=3618abea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3618abea",
  null
  
)

export default component.exports